
    jQuery(document).ready(function($){
      $('.testimonial-slider').slick({
        dots: false,             // Removes pagination dots
        arrows: true,           // Adds navigation arrows
        infinite: true,         // Infinite looping
        autoplay: false,         // Disables autoplay
        autoplaySpeed: 3000,    // Autoplay speed (in ms)
        speed: 500,             // Transition speed
        slidesToShow: 1,        // Shows one slide at a time
        slidesToScroll: 1       // Scrolls one slide at a time
      });
    });

jQuery(document).ready(function($){
  $('#solutionlist').slick({
    dots: false,             // Removes pagination dots
    arrows: true,           // Adds navigation arrows
    infinite: true,         // Infinite looping
    autoplay: true,         // Disables autoplay
    autoplaySpeed: 3000,    // Autoplay speed (in ms)
    speed: 500,             // Transition speed
    slidesToShow: 4,        // Shows one slide at a time
    slidesToScroll: 1       // Scrolls one slide at a time
  });
});